import React, { useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import ServicesPage from './components/ServicesPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import SafeDrivingPage from './components/SafeDrivingPage';
import MoneySavingPage from './components/MoneySavingPage';
import InsuranceQuoteForm from './components/InsuranceQuoteForm';
import ClaimsForm from './components/ClaimsForm';
import ChatBot from './components/ChatBot';
import FloatingChatButton from './components/FloatingChatButton';
import ProtectedRoute from './components/ProtectedRoute';
import QuotesHistory from './components/QuotesHistory';
import ClaimsHistory from './components/ClaimsHistory';
import { AuthProvider } from './contexts/AuthContext';
import './aws-config';
import './App.css';

type Page = 'home' | 'services' | 'about' | 'contact' | 'quote' | 'claims' | 'safe-driving' | 'money-saving' | 'chatbot' | 'quotes-history' | 'claims-history';

function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');

  const navigateToQuote = () => {
    setCurrentPage('quote');
  };

  const navigateToClaims = () => {
    setCurrentPage('claims');
  };

  const navigateToServices = () => {
    setCurrentPage('services');
  };

  const navigateToAbout = () => {
    setCurrentPage('about');
  };

  const navigateToContact = () => {
    setCurrentPage('contact');
  };

  const navigateToSafeDriving = () => {
    setCurrentPage('safe-driving');
  };

  const navigateToMoneySaving = () => {
    setCurrentPage('money-saving');
  };

  const navigateToChatbot = () => {
    setCurrentPage('chatbot');
  };

  const navigateToQuotesHistory = () => {
    setCurrentPage('quotes-history');
  };

  const navigateToClaimsHistory = () => {
    setCurrentPage('claims-history');
  };

  const navigateToHome = () => {
    setCurrentPage('home');
  };

  const renderBackButton = () => (
    <div style={{
      position: 'fixed',
      top: '20px',
      left: '20px',
      zIndex: 1000
    }}>
      <button
        onClick={navigateToHome}
        style={{
          background: 'rgba(255, 255, 255, 0.9)',
          border: '2px solid #667eea',
          color: '#667eea',
          padding: '0.5rem 1rem',
          borderRadius: '25px',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '0.9rem',
          transition: 'all 0.3s ease'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.background = '#667eea';
          e.currentTarget.style.color = 'white';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
          e.currentTarget.style.color = '#667eea';
        }}
      >
        ← Back to Home
      </button>
    </div>
  );

  return (
    <AuthProvider>
      <div className="App">
        {currentPage === 'quote' ? (
          <div>
            {renderBackButton()}
            <ProtectedRoute>
              <InsuranceQuoteForm />
            </ProtectedRoute>
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'claims' ? (
          <div>
            {renderBackButton()}
            <ProtectedRoute>
              <ClaimsForm />
            </ProtectedRoute>
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'services' ? (
          <div>
            <Header onNavigate={setCurrentPage} />
            <ServicesPage onNavigateToQuote={navigateToQuote} onNavigateToClaims={navigateToClaims} onNavigateToChatbot={navigateToChatbot} />
            <Footer />
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'about' ? (
          <div>
            <Header onNavigate={setCurrentPage} />
            <AboutPage />
            <Footer />
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'contact' ? (
          <div>
            <Header onNavigate={setCurrentPage} />
            <ContactPage onNavigateToChatbot={navigateToChatbot} />
            <Footer />
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'safe-driving' ? (
          <div>
            {renderBackButton()}
            <SafeDrivingPage onNavigateToChatbot={navigateToChatbot} />
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'money-saving' ? (
          <div>
            {renderBackButton()}
            <MoneySavingPage onNavigateToChatbot={navigateToChatbot} />
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        ) : currentPage === 'chatbot' ? (
          <div>
            {renderBackButton()}
            <ChatBot />
          </div>
        ) : currentPage === 'quotes-history' ? (
          <div>
            {renderBackButton()}
            <QuotesHistory />
          </div>
        ) : currentPage === 'claims-history' ? (
          <div>
            {renderBackButton()}
            <ClaimsHistory />
          </div>
        ) : (
          <div>
            <Header onNavigate={setCurrentPage} />
            <HomePage
              onNavigateToQuote={navigateToQuote}
              onNavigateToClaims={navigateToClaims}
              onNavigateToSafeDriving={navigateToSafeDriving}
              onNavigateToMoneySaving={navigateToMoneySaving}
              onNavigateToChatbot={navigateToChatbot}
            />
            <Footer />
            <FloatingChatButton onClick={navigateToChatbot} />
          </div>
        )}
      </div>
    </AuthProvider>
  );
}

export default App;
